import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {loadLoadingState} from '../../../shared/utils/loadingStateLocalStorage';
import {Platform} from 'react-native';

export type ShowLoaderState = boolean;

const initialStateSetter = () => {
  const isStateSavedLocalStorage = Platform.OS === 'web' ? loadLoadingState() : false;
  if (isStateSavedLocalStorage) {
    return isStateSavedLocalStorage.isLoading;
  }
  return false;
};

const initialState: ShowLoaderState = initialStateSetter() as unknown as ShowLoaderState;

export const showLoaderSlice = createSlice({
  name: '@@eskso/loader/showLoader',
  initialState,
  reducers: {
    reset: () => initialState,
    setShowing: (_state, action: PayloadAction<boolean>) => action.payload,
  },
});
